<template>
    <v-app-bar app flat color="white" class="b-background">
        <v-toolbar-title class="ml-12">
            <!-- <v-img src="@/assets/logo-black.png" width="140"></v-img> -->
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <router-link to="/user-stores" class="b-signin-link"
            >Switch Account</router-link
        >
        <span @click="logout" class="b-signin-link">Logout</span>
    </v-app-bar>
</template>

<script>
import { mdiArrowRight } from "@mdi/js";
import API from "@/models/API";
import { mapMutations } from "vuex";

export default {
    name: "Header",

    data: () => ({
        icons: { mdiArrowRight },
    }),

    computed: {
        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        ...mapMutations(["setAccessToken"]),

        async logout() {
            try {
                const { data } = await API.post(`/users/logout`);

                localStorage.removeItem("storeId");
                localStorage.removeItem("companyId");
                localStorage.removeItem("accessToken");
                this.setAccessToken("");
                this.$router.push(`/${this.lang}/sign-in`);
            } catch (ex) {
                console.log(ex.response.data);
            }
        },
    },
};
</script>

<style scoped>
.theme--light.v-btn:hover {
    color: #007bff;
}

.theme--light.v-btn:hover::before {
    opacity: 0 !important;
}

.b-background {
    background-image: linear-gradient(
        147deg,
        rgba(141, 141, 236, 0.17) 0%,
        rgba(84, 84, 212, 0) 100%
    );
}

.b-signin-link {
    color: rgba(0, 0, 0, 0.87);
    margin-right: 48px;
    font-weight: 600;
    text-decoration: none;
}

.b-signin-link:hover {
    text-decoration: underline;
}
</style>

<style scoped>
.b-signin-link {
    cursor: pointer;
}
</style>
